import { useQuery, useMutation } from 'react-query'
import axios from 'axios'
import { baseUrl, GenericQueryOptions } from '.'
import { longStaleTime } from 'BrokerTsLib/src/hooks'
import { PersonAdditionalData, SimpleItem } from 'BrokerTsLib/src/dtos'
import { AresData, User, OkKlientSpec } from 'BrokerTsLib/src/dtos/User'

const userApiUrl = process.env.REACT_APP_USER_API
const url = `${baseUrl}/${userApiUrl}`

const fetchUser = () => axios.get<User[]>(`${url}/GetUsers`)

export const useGetUsers = (options?: GenericQueryOptions<User[]>) =>
  useQuery(['useGetAll'], () => fetchUser(), { staleTime: longStaleTime, ...options })

const fetchOu = () => axios.get<SimpleItem[]>(`${url}/GetOrganizationUnits`)

export const useGetOrganizationUnits = (options?: GenericQueryOptions<SimpleItem[]>) =>
  useQuery(['useGetOrganizationUnits'], () => fetchOu(), { staleTime: longStaleTime, ...options })

export const useGetAres = (ic: string, options?: GenericQueryOptions<AresData>) =>
  useQuery(['useGetAres', ic], () => axios.get<AresData>(`${url}/GetAres?ic=${ic}`), {
    staleTime: longStaleTime,
    ...options,
  })

export const fetchOkKlientSpec = () => axios.get<OkKlientSpec>(`${url}/BelongsToOkKlient`)

export const useGetBirthdate = (birthnumber?: string, options?: GenericQueryOptions<Date>) =>
  useQuery(['useGetBirthdate', birthnumber],
    () => axios.get<Date>(`${url}/GetBirthdateFromBirthnumber?birthnumber=${birthnumber}`),
    {
      staleTime: longStaleTime,
      ...options
    })

export const useFindPerson = () =>
  useMutation((birthnumber?: string) =>
    axios.post<PersonAdditionalData>(`${url}/FindPerson?birthnumber=${birthnumber}`))